import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Table, Row, Col, Spinner } from 'react-bootstrap';
import { Formik } from 'formik';
//import {Helmet} from "react-helmet";
import { useNavigate, useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from '../../util/Api';
import { useSelector } from 'react-redux';
import { getUserAccounts } from '../../app/slices/UserSlice';
import ExperimentReport from './components/ExperimentReport';
//import {string, object} from 'yup';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  //name: Yup.string().required('a name is required.'),
  //typeId: Yup.string().required('a type is required.'),
  maxTokens: Yup.number().typeError('Max Tokens must be an integer').nullable(),
  temperature: Yup.number().typeError('Temperature must be a decimal').nullable(),
  topP: Yup.number().typeError('Top P must be a decimal').nullable(),
  topK: Yup.number().typeError('Top K must be a decimal').nullable(),
  presencePenalty: Yup.number().typeError('Presence Penalty must be a decimal').nullable(),
  frequencyPenalty: Yup.number().typeError('Frequency Penalty must be a decimal').nullable(),
  countPenalty: Yup.number().typeError('Count Penalty must be a decimal').nullable(),
});

//TODO: give the ability to change the region on AWS - i.e. run from West Coast, East Coast, EU, APAC
//this being the case - may want separate functions

const ExperimentForm = () => {
  const [errors, setErrors] = useState([]);
  const [models, setModels] = useState([]);
  const [providers, setProviders] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showProviderConfig, setShowProviderConfig] = useState(false);

  const [experimentErrors, setExperimentErrors] = useState([]);
  const [showRunning, setShowRunning] = useState(false)
  const [experiments, setExperiments] = useState([]);

  //use this to track models selected
  const [selectedModels, setSelectedModels] = useState([]);
  const [prompts, setPrompts] = useState([]);

  let { accountKey } = useParams();
  const currUserAccounts = useSelector(getUserAccounts);
  const currUserAccount = currUserAccounts.find(a => a.accountKey === accountKey);
  const currRoleId = currUserAccount ? currUserAccount.roleId : 0;

  let navigate = useNavigate();

  useEffect(() => {
    document.title = `reconify create experiment`;

    //get models account has access too
    axios.post(apiUrl + '/providerkeys/providers', {
      accountKey: accountKey
    }, { withCredentials: true })
      .then((res) => {
        if (res.data.status === 'ok') {
          let providers = res.data.providers
          if (providers.length > 0) {
            setProviders(providers)
            setShowForm(true)
            setShowProviderConfig(false)
          } else {
            setShowForm(false)
            setShowProviderConfig(true)
          }
        } else {
          setShowForm(false)
          setShowProviderConfig(true)
        }
      })
      .catch((err) => {
        //console.log(err)
        setErrors(['There was an error retrieving Gen AI Providers'])
      });

    //accounts belonging to user
    //if account passed in, use that
    //possibly reuse this if want to limit experiments
    //should put limit on experiments then charge small fee - 10/mon?
    /*
    if(!accountKey) {
      axios.post(apiUrl + '/accounts/useraccounts',
        {
          minRoleId: 2
        }, {withCredentials: true})
      .then((res) => {
        if(res.data.status === 'ok') {
          //if(res.data.accounts > 1) {
          if(Array.isArray(res.data.accounts) && res.data.accounts.length > 1) {
          //if(res.data.accounts.length > 1) {
            //console.log('accounts:', res.data.accounts)
            setAccounts(res.data.accounts);
          }
          else {
            //console.log('account:', res.data.accounts[0])
            setDefaultAccountKey(res.data.accounts[0].accountKey)
          }
        }
      })
      .catch((err) => {

      });
    } else {
      setDefaultAccountKey(accountKey)
    }
    */

  }, [accountKey]);

  const handleProviderChange = (e) => {
    //update models - show model dropdown 
    let providerId = e.currentTarget.value
    let provider = providers.find(p => p.providerId === parseInt(providerId))
    //console.log(provider)
    if (provider != null && provider.models.length > 0) {
      setModels(provider.models);
    } else {
      setModels([])
    }

  }

  const submitSubmit = (values, actions) => {
    //console.log("submitting experiment form", JSON.stringify(values));
    setErrors([]);
    setExperimentErrors([]);


    //need to add models to submit
    //let modelIds = selectedModels.map(m => m.modelId)
    let modelIds = selectedModels.map(m => { return { modelId: m.modelId, providerId: m.providerId } })
    //console.log(modelIds)
    if (modelIds.length < 1) {
      //error - need to select a model
      setExperimentErrors(['Select one or more models to use'])
    }
    else if (prompts.length < 1) {
      setExperimentErrors(['Add one or more prompts'])
    } else {
      setShowRunning(true)
      setExperiments([])
      
      /*
      values.models = modelIds
      values.prompts = prompts;
      values.accountKey = accountKey;
      console.log('updated values:', JSON.stringify(values));
      */
      let options = {
        accountKey: accountKey,
        models: modelIds,
        prompts: prompts
      }
      if(values.type != null) { options.type = values.type}
      if(values.temperature != null) { options.temperature = parseFloat(values.temperature)}
      if(values.maxTokens != null) { options.maxTokens = parseInt(values.maxTokens)}
      if(values.topP != null) { options.topP = parseFloat(values.topP)}
      if(values.topK != null) { options.topK = parseFloat(values.topK)}
      if(values.presencePenalty != null) { options.presencePenalty = parseFloat(values.presencePenalty)}
      if(values.frequencyPenalty != null) { options.frequencyPenalty = parseFloat(values.frequencyPenalty)}
      if(values.countPenalty != null) { options.countPenalty = parseFloat(values.countPenalty)}
      if(values.stopSequences != null) { options.stopSequences = parseInt(values.stopSequences)}
      //console.log(options)

      let isAuthError = false;

      axios.post(apiUrl + '/experiments/create', options, { withCredentials: true })
        .then((res) => {
          //console.log('logged in');
          //console.log("add results:", res.data);
          if (res.data.status === "ok" && res.data.experiments) {
            //show results 
            setShowRunning(false)
            let experiments = res.data.experiments
            //console.log(JSON.stringify(experiments))
            setExperiments(experiments)
          }
          else {
            //console.log('an error was returned');
            //display errors
            let errorMsgs = [];
            //reset TOS link?
            //values.tosAgree = [];
            let redirectToLogin = false;
            res.data.errors.forEach((error, i) => {
              switch (error) {
                case 'auth-expired':
                case 'auth-error':
                case 'no-auth':
                case 'no-valid-account':
                  //console.log('auth expired');
                  isAuthError = true;
                  //errorMsgs.push('You have been logged out.');
                  //return;
                  redirectToLogin = true;
                  break;
                case 'no-permissions':
                  errorMsgs.push('Your do not have permissions to create an experiment.');
                  break;
                case 'no-prompt':
                  errorMsgs.push('Please provide a prompt.');
                  break;
                case 'no-model':
                  errorMsgs.push('Please provide a model.');
                  break;
                case 'name-missing':
                  errorMsgs.push('Please enter a name for the experiment.');
                  break;
                default:
                  errorMsgs.push('There was an error creating the experiment.');
              }
            });
            if (redirectToLogin) {
              navigate('/login');
              return;
            }
            //don't call setErrors if not logged in as it throws an unmounted error
            if (!isAuthError) {
              setExperimentErrors(errorMsgs);
              setShowRunning(false)
            }
            //setErrors(errorMsgs);
          }
        })
        .catch((err) => {
          setExperimentErrors(['An error occurred while running the experiment.']);
          setShowRunning(false)
        });
    }


  }

  const sortByProvider = () => {
    let temp = [...selectedModels]
    temp.sort((a, b) => (a.provider < b.provider) ? -1 : 1)
    setSelectedModels(temp);
  }
  const sortByModel = () => {
    let temp = [...selectedModels]
    temp.sort((a, b) => (a.model < b.model) ? -1 : 1)
    setSelectedModels(temp);
  }
  const addModel = () => {
    let temp = [...selectedModels]
    let providerId = document.getElementById('providerId').value;
    let modelId = document.getElementById('modelId').value


    //console.log("providerId:" + providerId)
    //console.log("modelId:" + modelId)

    let provider = providers.find(p => p.providerId === parseInt(providerId))
    if (provider != null) {
      let model = provider.models.find(m => m.modelId === parseInt(modelId))
      if (model != null) {
        model.provider = provider.provider
        model.providerId = provider.providerId
        //make sure it's not already in the list
        let existingModels = new Set(temp.map(m => m.modelId))
        if (!existingModels.has(modelId)) {
          temp.push(model)
          setSelectedModels(temp)
        }

        //clear 
        document.getElementById('modelId').value = "";
        document.getElementById('providerId').value = "";
      }

    }


    //console.log('provider: ' +providerId)


  }
  const deleteModel = (modelId) => {
    let temp = [...selectedModels]
    temp = temp.filter(model => model.modelId !== parseInt(modelId))
    setSelectedModels(temp)
  }

  const sortByPrompt = () => {
    let temp = [...prompts]
    temp.sort((a, b) => (a.prompt < b.prompt) ? -1 : 1)
    setPrompts(temp);
  }
  const sortByRole = () => {
    let temp = [...prompts]
    temp.sort((a, b) => (a.role < b.role) ? -1 : 1)
    setPrompts(temp);
  }
  const addPrompt = () => {
    let temp = [...prompts]
    let text = document.getElementById('prompt').value;
    let role = document.getElementById('role').value
    temp.push({
      role: role,
      prompt: text
    })
    setPrompts(temp)
    //clear 
    document.getElementById('prompt').value = "";
    document.getElementById('role').value = "";
  }
  const deletePrompt = (idx) => {
    let temp = [...prompts]
    temp.splice(idx, 1)
    setPrompts(temp)
  }

  //check if logged in
  return (
    <div>

      <h3>Create an Experiment</h3>

      {
        errors.length > 0 ? (
          <Alert variant='danger'>
            {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
          </Alert>
        ) : (null)
      }
      {showProviderConfig ? (
        <Alert variant='info'>
          <p>
            To use the benchmarking experimentation tool, first add API Keys for the
            Gen AI providers you want to use to your <Link to={`/account/${accountKey}/account`}>account</Link>.
          </p>
          {/*<p>
            For more info on how, learn how to get API Keys.
          </p>*/}
        </Alert>
      ) : null}

      {
        showForm ? (
          <>
            <p>
              Use the form below to experiment with and compare different Gen AI providers and models.
            </p>
            <Formik validationSchema={validationSchema}
              onSubmit={submitSubmit}
              initialValues={{
                //accountKey: '',
                type: null,
                temperature: null,
                maxTokens: null,
                topP: null,
                topK: null,
                presencePenalty: null,
                frequencyPenalty: null,
                countPenalty: null,
                stopSequences: null
                //typeId:''  
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors
              }) => (
                <Form noValidate onSubmit={handleSubmit} >

                  <h4 className='mt-5'>Experiment Type</h4>
                  <div className='chart-card'>
                    <Row>
                      <Col xs="auto">
                      <Form.Group controlId='type' className='mb-3'>
                          {/*<Form.Label>Type</Form.Label>*/}
                          <Form.Control as="select" name="type" onChange={handleChange}>
                            <option value="">Select Type</option>
                            <option value="chat">Chat</option>
                            <option value="compeletion">Generate/Completion</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                      
                  </div>

                  <h4 className='mt-5'>Gen AI Providers</h4>

                  <div className='chart-card'>
                    {
                      selectedModels.length > 0 ? (
                        <Table hover>
                          <thead>
                            <tr>
                              <th><span onClick={sortByProvider} role="button">Provider</span></th>
                              <th><span onClick={sortByModel} role="button">Model</span></th>
                              <th ></th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedModels.map((model, i) => (
                              <tr key={`selectedModel.${model.modelId}`}>
                                <td>{model.provider}</td>
                                <td>{model.model}</td>
                                <td><Button onClick={() => { deleteModel(model.modelId) }} variant='danger' size='sm'>remove</Button></td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      ) : (
                        <Alert variant='info'>

                          Add one or more models to use.

                        </Alert>
                      )
                    }
                    <Row>
                      <Col>
                        <Form.Group controlId='providerId' className='mb-3'>
                          {/*<Form.Label>Provider</Form.Label>*/}
                          <Form.Control as="select" name="providerId" onChange={handleProviderChange}>
                            <option value="0">Select Provider</option>
                            {
                              providers.length > 0 ? (
                                <>
                                  {providers.map((provider, i) => (<option key={`provider.${provider.providerId}`} value={provider.providerId}>{provider.provider}</option>))}
                                </>
                              ) : (null)
                            }
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId='modelId' className='mb-3'>
                          {/*<Form.Label>Model</Form.Label>*/}
                          <Form.Control as="select" name="modelId" onChange={handleChange}>
                            <option value="0">Select Model</option>
                            {
                              models.length > 0 ? (
                                <>
                                  {models.map((model, i) => (<option key={`model.${model.modelId}`} value={model.modelId}>{model.model}</option>))}
                                </>
                              ) : (null)
                            }
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>

                        <Button variant="primary" onClick={addModel}>Add Model</Button>

                      </Col>
                    </Row>
                  </div>

                  <h4 className='mt-5'>Prompts</h4>

                  <div className='chart-card'>
                    {
                      prompts.length > 0 ? (
                        <Table hover>
                          <thead>
                            <tr>
                              <th><span onClick={sortByRole} role="button">Role</span></th>
                              <th><span onClick={sortByPrompt} role="button">Prompt</span></th>
                              <th ></th>
                            </tr>
                          </thead>
                          <tbody>
                            {prompts.map((prompt, i) => (
                              <tr key={`prompt.${i}`}>
                                <td>{prompt.role}</td>
                                <td>{prompt.prompt}</td>
                                <td><Button onClick={() => { deletePrompt(i) }} variant='danger' size='sm'>remove</Button></td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      ) : (
                        <Alert variant='info'>

                          Add one or more prompts.

                        </Alert>
                      )
                    }
                    <Row>
                      <Col>
                        <Form.Group controlId='role' className='mb-3'>
                          {/*<Form.Label>Role</Form.Label>*/}
                          <Form.Control as="select" name="role" onChange={handleChange}>
                            <option value="">Select Role</option>
                            <option value="assistant">Assistant</option>
                            <option value="system">System</option>
                            <option value="user">User</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId='prompt' className='mb-3'>
                          {/*<Form.Label>Prompt <span className='required-field'>*</span></Form.Label>*/}

                          <Form.Control as="textarea" rows={3} placeholder="Enter the prompt"
                            name="prompt" onChange={handleChange}
                            isInvalid={touched.prompt && errors.prompt}
                          />
                          <Form.Control.Feedback type="invalid">{errors.prompt}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>

                        <Button variant="primary" onClick={addPrompt}>Add Prompt</Button>

                      </Col>
                    </Row>
                  </div>

                  <h4 className='mt-5'>Optional Parameters</h4>

                  <div className='chart-card'>
                    <Row>
                      <Col>
                        <Form.Group controlId='maxTokens' className='mb-3'>
                          <Form.Label>Max Tokens</Form.Label>
                          <Form.Control type="text" placeholder="Max Tokens"
                            name="maxTokens" onChange={handleChange}
                            isInvalid={touched.maxTokens && errors.maxTokens}
                          />
                          <Form.Control.Feedback type="invalid">{errors.maxTokens}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId='temperature' className='mb-3'>
                          <Form.Label>Temperature</Form.Label>
                          <Form.Control type="text" placeholder="Temperature"
                            name="temperature" onChange={handleChange}
                            isInvalid={touched.temperature && errors.temperature}
                          />
                          <Form.Control.Feedback type="invalid">{errors.temperature}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId='topP' className='mb-3'>
                          <Form.Label>Top P</Form.Label>
                          <Form.Control type="text" placeholder="Top P"
                            name="topP" onChange={handleChange}
                            isInvalid={touched.topP && errors.topP}
                          />
                          <Form.Control.Feedback type="invalid">{errors.topP}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId='topK' className='mb-3'>
                          <Form.Label>Top K</Form.Label>
                          <Form.Control type="text" placeholder="Top K"
                            name="topK" onChange={handleChange}
                            isInvalid={touched.topK && errors.topK}
                          />
                          <Form.Control.Feedback type="invalid">{errors.topK}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group controlId='presencePenalty' className='mb-3'>
                          <Form.Label>Presence Penalty</Form.Label>
                          <Form.Control type="text" placeholder="Presence Penalty"
                            name="presencePenalty" onChange={handleChange}
                            isInvalid={touched.presencePenalty && errors.presencePenalty}
                          />
                          <Form.Control.Feedback type="invalid">{errors.presencePenalty}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId='frequencyPenalty' className='mb-3'>
                          <Form.Label>Frequency Penalty</Form.Label>
                          <Form.Control type="text" placeholder="Frequency Penalty"
                            name="frequencyPenalty" onChange={handleChange}
                            isInvalid={touched.frequencyPenalty && errors.frequencyPenalty}
                          />
                          <Form.Control.Feedback type="invalid">{errors.frequencyPenalty}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId='countPenalty' className='mb-3'>
                          <Form.Label>Count Penalty</Form.Label>
                          <Form.Control type="text" placeholder="Count Penalty"
                            name="countPenalty" onChange={handleChange}
                            isInvalid={touched.countPenalty && errors.countPenalty}
                          />
                          <Form.Control.Feedback type="invalid">{errors.countPenalty}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId='stopSequences' className='mb-3'>
                          <Form.Label>Stop Sequences</Form.Label>
                          <Form.Control type="text" placeholder="Stop Sequences"
                            name="stopSequences" onChange={handleChange}
                            isInvalid={touched.stopSequences && errors.stopSequences}
                          />
                          <Form.Control.Feedback type="invalid">{errors.stopSequences}</Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                  <div className='my-3'>
                    <Button variant="primary" type="submit">Run Experiment</Button>
                  </div>

                </Form>
              )}
            </Formik>
            {
              experimentErrors.length > 0 ? (
                <Alert variant='danger'>
                  {experimentErrors.map((err, i) => (<div key={'exErr.' + i}>{err}</div>))}
                </Alert>
              ) : (null)
            }
            {
              showRunning === true ? (
                <Alert variant='primary'>
                  <div className='d-inline-flex'>
                    <div><Spinner animation="border" variant='primary' /></div>
                    <div className='ms-3'>Running experiment </div>
                  </div>

                </Alert>
              ) : null
            }
            {experiments.length > 0 ? (
              <ExperimentReport accountKey={accountKey} experiments={experiments} />
            ) : null}

          </>
        ) : null
      }



    </div>
  );
}

export default ExperimentForm;
